module.exports = "<hybse-admin-symbol [isDemo]=\"true\"></hybse-admin-symbol>"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-symbol/demo-symbol.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-symbol/demo-symbol.component.html
// module chunks = main